import React from "react";
var Disclaimer = function(param) {
    var intl = param.intl, disclaimerText = param.disclaimerText, acceptDisclaimer = param.acceptDisclaimer;
    return /*#__PURE__*/ React.createElement("div", {
        className: "chart-error__disclaimer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "chart-error__disclaimer-reason"
    }, intl.formatMessage({
        id: "charterror.disclaimer.reason",
        defaultMessage: "Please accept the Disclaimer first"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "chart-error__disclaimer-text",
        dangerouslySetInnerHTML: {
            __html: disclaimerText
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "chart-error__diclaimer-footer"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "btn",
        onClick: function(evnt) {
            evnt.preventDefault();
            acceptDisclaimer();
        }
    }, intl.formatMessage({
        id: "social.activities.accept_disclaimer",
        defaultMessage: "Accept"
    }))));
};
export default Disclaimer;
